<template>
  <div>
    <div class="dialogContainer">
      <el-form
        ref="handleForm"
        :model="handleForm"
        :rules="handleRules"
        label-position="right"
        label-width="90px"
      >
        <el-form-item label="内容" prop="content">
          <el-input
            v-model="handleForm.content"
            type="textarea"
            :rows="6"
            placeholder="请输入内容"
            class="handle-form-input"
            maxlength="42"
            show-word-limit
          />
        </el-form-item>
        <el-form-item label="原著" prop="original">
          <el-input
            v-model="handleForm.original"
            name="title"
            placeholder="请输入原著"
            maxlength="30"
            class="handle-form-input"
          />
        </el-form-item>
        <el-form-item label="作者" prop="author">
          <el-input
            v-model="handleForm.author"
            name="slogan"
            placeholder="请输入作者"
            maxlength="20"
            class="handle-form-input"
          />
        </el-form-item>
        <el-form-item label="对象" prop="stages">
          <el-checkbox-group v-model="checkList" @change="handlechange">
            <el-checkbox :label="`1`">
              小学
            </el-checkbox>
            <el-checkbox :label="`2`">
              中学
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="medium" @click="closeDialog">
        取消
      </el-button>
      <el-button
        :loading="ajaxLoading"
        type="primary"
        size="medium"
        @click="handleAddSubject"
      >
        {{ ajaxLoading?'Loading':'立即发布' }}
      </el-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
// 获取API
import {
  demandsensitivewordsCheck
} from '@/api/systemManage/sensitiveManage';
// 获取API
import { getProsepoemsAdd, getProsepoemsEdit } from '@/api/productOperation/mrDesk/prosepoems';
export default {
  name: 'DialogInfo',
  props: {
    type: {
      type: String,
      default: null
    },
    dataList: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      checkList: [],
      fileList: [],
      ajaxLoading: false,
      CascaderOptions: [],
      // 操作表单
      handleForm: {
        content: '',
        original: '',
        author: '',
        stages: '',
        id: ''
      },

      handleRules: {
        content: [
          { required: true, message: '散文诗句内容不能为空', trigger: 'blur' }
        ],
        original: [
          { required: true, message: '散文诗句原著不能为空', trigger: 'blur' }
        ],
        author: [
          { required: true, message: '散文诗句作者不能为空', trigger: 'blur' }
        ],
        stages: [
          { required: true, message: '发布对象不能为空', trigger: 'blur' }
        ]
      }
    };
  },
  computed: {
    // 获取上传图片地址
    ...mapGetters(['consultingcontentsUrl'])
  },
  watch: {
    dataList: {
      handler(val) {
        if (val) {
          if (this.type === 'edit') {
            const data = val;
            this.handleForm = {
              id: data.id,
              content: data.content,
              original: data.original,
              author: data.author,
              stages: data.stages
            };
            this.checkList = data.stages.split(',');
          } else {
            this.handleForm = {
              content: '',
              original: '',
              author: '',
              id: '',
              linkType: 1,
              stages: '1'
            };
            this.checkList = ['1'];
          }
        }
      }
    }
  },
  mounted() {
    if (this.type === 'edit') {
      const data = this.dataList;
      this.handleForm = {
        id: data.id,
        content: data.content,
        original: data.original,
        author: data.author,
        stages: data.stages
      };
      this.checkList = data.stages.split(',');
    } else {
      this.handleForm = {
        content: '',
        original: '',
        author: '',
        id: '',
        linkType: 1,
        stages: '1'
      };
      this.checkList = ['1'];
    }
  },
  methods: {
    // 新增
    handleAddSubject() {
      this.$refs['handleForm'].validate(valid => {
        if (valid) {
          var content = {
            content: this.handleForm.content
          };
          demandsensitivewordsCheck(content).then(response => {
            if (response.data && response.data.isChoose) {
              this.$message({
                type: 'warning',
                message: response.data.badword
              });
              return;
            } else {
              this.ajaxLoading = true;
              if (this.type === 'add') { // 添加
                this.handleForm.stages = this.checkList.length > 0 ? this.checkList.join(',') : this.checkList.join('');
                const option = {
                  content: this.handleForm.content,
                  original: this.handleForm.original,
                  author: this.handleForm.author,
                  stages: this.handleForm.stages
                };
                getProsepoemsAdd(option)
                  .then(res => {
                    this.$emit('closeDialog');
                    this.ajaxLoading = false;
                  }).catch(err => {
                    this.ajaxLoading = false;
                    console.log(err);
                  });
              } else { // 编辑
                this.handleForm.stages = this.checkList.length > 0 ? this.checkList.join(',') : this.checkList.join('');
                const option1 = {
                  id: this.handleForm.id,
                  content: this.handleForm.content,
                  original: this.handleForm.original,
                  author: this.handleForm.author,
                  stages: this.handleForm.stages
                };
                getProsepoemsEdit(option1)
                  .then(res => {
                    this.$emit('closeDialog');
                    this.ajaxLoading = false;
                  }).catch(err => {
                    this.ajaxLoading = false;
                    console.log(err);
                  });
              }
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handlechange(val) {
      this.handleForm.stages = val.length > 0 ? val.join(',') : val.join('');
    },
    // 关闭
    closeDialog() {
      this.$emit('closeDialog');
    }
  }
};
</script>
<style lang="scss" scoped>
.dialogContainer {
}
.upload-picture {
  float: right;
}
.handle-form-input {
  width: 96%;
}
.picture-wrapper {
  width: 96%;
  height: 100px;
  margin-top: 10px;
  border: 1px dashed #dcdfe6;
  border-radius: 4px;
}
.dialog-footer {
  text-align: right;
  padding-top: 20px;
}
</style>
